export const ORDER_ADDRESS_LINE_MAX_LENGTH = 40;

const addressLineLabels = {
    lineOne: "Address Line 1",
    lineTwo: "Address Line 2",
    billingLineOne: "Billing Address Line 1",
    billingLineTwo: "Billing Address Line 2",
};

export const getAddressLineInputError = (fieldName, value) => {
    if (!addressLineLabels[fieldName]) return null;
    if (String(value || "").length > ORDER_ADDRESS_LINE_MAX_LENGTH) {
        return `${addressLineLabels[fieldName]} cannot exceed 40 characters.`;
    }
    return null;
};

export const validateOrderAddressLines = ({
    lineOne,
    lineTwo,
    billingLineOne,
    billingLineTwo,
} = {}) =>
    getAddressLineInputError("lineOne", lineOne) ||
    getAddressLineInputError("lineTwo", lineTwo) ||
    getAddressLineInputError("billingLineOne", billingLineOne) ||
    getAddressLineInputError("billingLineTwo", billingLineTwo);
